export default "__VITE_ASSET__DlAatgv9__ 100w";